// ULTRA-OPTIMIZED SCROLL VIDEO - HANDLES LARGE FILES
// Aggressive throttling + minimal repaints

document.addEventListener('DOMContentLoaded', () => {
  const video = document.querySelector('[data-scroll-video]');
  const logo = document.querySelector('.hero-video-scroll__logo');
  const shirt = document.querySelector('.hero-video-scroll__shirt');
  
  if (!video) return;
  
  const REVEAL_THRESHOLD = 0.65;
  const SCROLL_DELTA = 0.008; // Only update if significant change
  
  let revealed = false;
  let rafId = null;
  let lastScrollProgress = 0;
  let videoReady = false;
  
  // Reduce video quality for web
  video.style.opacity = '0.95';
  
  video.addEventListener('loadedmetadata', () => {
    videoReady = true;
    const scrollableHeight = document.querySelector('.hero-video-scroll').scrollHeight - window.innerHeight;
    
    const updateVideoOnScroll = () => {
      if (!videoReady) return;
      
      const scrollProgress = window.scrollY / scrollableHeight;
      const clampedProgress = Math.min(1, Math.max(0, scrollProgress));
      
      // Only update on significant deltas
      if (Math.abs(clampedProgress - lastScrollProgress) > SCROLL_DELTA) {
        // Batch video updates: skip frames on large files
        video.currentTime = clampedProgress * video.duration;
        lastScrollProgress = clampedProgress;
        
        // Reveal/hide with minimal DOM thrashing
        if (clampedProgress > REVEAL_THRESHOLD && !revealed) {
          logo.classList.add('visible');
          shirt.classList.add('visible');
          revealed = true;
        } else if (clampedProgress <= REVEAL_THRESHOLD && revealed) {
          logo.classList.remove('visible');
          shirt.classList.remove('visible');
          revealed = false;
        }
      }
    };
    
    window.addEventListener('scroll', () => {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(updateVideoOnScroll);
    }, { passive: true, capture: false });
  });
  
  // Preload video
  video.preload = 'metadata';
});
